import {
  Component,
  ComponentFactoryResolver,
  ViewContainerRef,
  ViewEncapsulation,
  ComponentRef,
  EventEmitter,
  Output,
  Input,
  ChangeDetectorRef,
  ViewChild,
  Sanitizer
} from '@angular/core';
import { ContentType } from '../utils';
import { ModalComponent } from './modal.component';
import { FileReaderMenuComponent } from '../menus';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'file-reader',
    templateUrl: './file-reader.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
/**
 * API to an open modal window.
 */
export class FileReaderComponent {
  /**
   * Caption for the title.
   */

  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;

  @Input() public title: string;
  /**
   * component which is to be loaded dynamically.
   */
  public component: any;
  /**
   * Describes if the modal contains Ok Button.
   * The default Ok button will close the modal and emit the callback.
   * Defaults to true.
   */
  public okButton = true;
  /**
   * Caption for the OK button.
   * Default: Ok
   */
  public defaultokButtonText = 'Select';
  @Input() public okButtonText: string = this.defaultokButtonText;

  /**
   * Describes if the modal contains cancel Button.
   * The default Cancelbutton will close the modal.
   * Defaults to true.
   */
  public cancelButton = true;
  public closeButton = true;
  /**
   * Caption for the Cancel button.
   * Default: Cancel
   */
  public defaultCancelButtonText = 'Cancel';
  @Input() public cancelButtonText: string = this.defaultCancelButtonText;
  /**
   * if the modalMessage is true it will show the message inside modal body.
   */
  public modalMessage = true;
  /**
   * Some message/content can be set in message which will be shown in modal body.
   */
  @Input() public assetUrl: string;
  @Input() public content: string;
  @Input() public fileBox: any;
  @Input() public contentType: ContentType;
  /**
   * if the value is true modal footer will be visible or else it will be hidden.
   */
  public modalFooter = true;
  /**
   * shows modal header if the value is true.
   */
  public modalHeader = true;
  /**
   * if the value is true modal will be visible or else it will be hidden.
   */
  public isOpen = false;
  /**
   * Emitted when a ok button was clicked
   * or when close method is called.
   */
  /**
   * shows warning icon if the value is true.
   */
  public warningIcon = false;
  public contentTypes = ContentType;
  cmpRef: ComponentRef<any>;
  @Output() public confirmOutput: EventEmitter<any> = new EventEmitter();
  @Output() public modalClosed: EventEmitter<any> = new EventEmitter();

  constructor(
    public componentFactoryResolver: ComponentFactoryResolver,
    public viewContainer: ViewContainerRef,
    private cdf: ChangeDetectorRef,
    public sanitizer: DomSanitizer
  ) {}
  open(component?: any, data?: any) {
    this.isOpen = true;
    this.cdf.detectChanges();
  }
  /**
   *  close method dispose the component, closes the modal and optionally emits confirmOutput value.
   */
  close(data?: any) {
    this.dispose();
    if (data) {
      this.confirmOutput.emit(data);
    } else if (this.modalClosed) {
      this.modalClosed.emit(null);
    }
  }
  /**
   *  ok method dispose the component, closes the modal and emits true.
   */
  submit() {
    this.dispose();
    this.confirmOutput.emit(this.fileBox || this.assetUrl || this.content);
  }
  /**
   *  dispose method dispose the loaded component.
   */
  dispose() {
    this.isOpen = false;
    if (this.component !== undefined) {
      this.component.then((componentRef: ComponentRef<any>) => {
        componentRef.destroy();
        return componentRef;
      });
    }
  }

  public openMenu(): void {
    this.menuModal.modalFooter = false;
    this.menuModal.modalHeader = false;
    this.menuModal.modalMessage = false;
    this.menuModal.open(FileReaderMenuComponent);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.rename();
        break;
      case 2:
        this.replace();
        break;
      case 3:
        this.copy();
        break;
      case 4:
        this.delete();
        break;
      default:
    }
  }

  rename() {}

  replace() {}

  delete() {}

  copy() {}

  getFileBoxUrl(fileBox: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`/api/assets/${fileBox.assetId}/content`);
  }
}
